import * as React from 'react';

import { Textarea } from '@/components/ui/textarea';

interface TaskInternalNotesProps {
  notes: string;
  onNotesChange: (notes: string) => void;
}

export const TaskInternalNotes: React.FC<TaskInternalNotesProps> = ({
  notes,
  onNotesChange,
}) => {
  const [localNotes, setLocalNotes] = React.useState(notes);

  // Update local notes when prop changes
  React.useEffect(() => {
    setLocalNotes(notes);
  }, [notes]);

  const handleChange = (value: string) => {
    setLocalNotes(value);
    onNotesChange(value);
  };

  return (
    <div className="space-y-1.5">
      <div className="relative">
        <Textarea
          placeholder="Add description..."
          className="min-h-[80px] resize-none border-slate-300 focus:border-blue-500 focus:ring-blue-500 !text-xs text-slate-900 font-semibold"
          value={localNotes}
          onChange={(e) => handleChange(e.target.value)}
        />
      </div>
    </div>
  );
};
